import React, { useEffect, useRef } from "react";
import { Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./_photo-gallery-page.scss";
import { LinkIcon, Zoom } from '../../../../../resources/js/components/svgIcon';
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import ComingSoon from "../ComingSoon";

function PhotoAlbumDetail({ PageData, DetailRecord, Constant }) {
    const containerRef = useRef(null);
    const CDN_URL = window.cdn_path;
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        NativeFancybox.bind(container, "[data-fancybox]", {
            Carousel: { infinite: false },
        });

        return () => {
            NativeFancybox.unbind(container);
            NativeFancybox.close();
        };
    }, []);
    return (
       <section className="inner-page-gap photo-gallery-section" ref={containerRef}>
            {DetailRecord.gallery && DetailRecord.gallery.length > 0 ? (
                <Container>
                    <div className="grid-container">
                        {DetailRecord.gallery.map((galleryItem, index) => {
                            let firstImage = '';
                            if (galleryItem.varWebpImgURL) {
                                firstImage = CDN_URL + 'caches/' + Constant.GALLERYTHUMB.split(',')[0].replace('*', 'x') + '/' + galleryItem.varWebpImgURL;
                            } else {
                                firstImage = CDN_URL + 'assets/images/' + galleryItem.varImgURL;
                            }
                            return (
                                <div className="grid-item" key={index}>
                                    <Link>
                                        <Image
                                            src={firstImage}
                                            alt={galleryItem.varTitle}
                                            title={galleryItem.varTitle}
                                            width="200"
                                            height="150"
                                        />
                                    </Link>
                                    <Link className="marked" data-fancybox="gallery" to={firstImage}>
                                        <span className="icon">
                                            <i><Zoom/></i>
                                        </span>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                </Container>
            ) : (
                <div>
                    <ComingSoon/>
                </div>
            )}
        </section>
    );
}

export default PhotoAlbumDetail;